import {Filter} from 'react-admin'
export const ClubPointsDetailsFilter = (props) => (
	<Filter {...props}>
	</Filter>
)
export default ClubPointsDetailsFilter